<template>
  <div class="homepage" style="background:#fff;">
    <div class="flood">
      <div class="title"><span>水旱灾害场景分析</span></div>
      <div class="contain picblock">
        <div class="itembanner" @click="todetail(item.menuInfo.url,item)" v-for="(item,index) in bannerswiper" :key="index">
          <div class="pic">
            <img :src="item.imgurl" alt="">
          </div>
          <div class="desc"><span>{{item.menuInfo.name}}</span></div>
        </div>
      </div>
    </div>
    <div class="application">
      <div class="contain">
        <div class="often">
          <div class="title"><span>常用专题应用</span></div>
          <!-- <div @click="todetail(item.routerurl)" v-for="(item,index) in oftenapps" :key="index" :class="[index === 0 ? 'first' : '', 'itemicon']">
            <div :class="[index === 9 ? 'edit' : '', 'iconbg']" :style="'background:#'+ item.bgcolor">
              <svg class="icon" aria-hidden="true" style="color:#fff;">
                <use :href="'#' + item.iconcode"></use>
              </svg>
            </div>
            <span>{{item.name}}</span>
          </div> -->
          <div
            v-for="(item,index) in commonApp"
            @click="todetail(item.menuInfo.url,item.menuInfo)"
            :key="index+'a'"
            :class="[index === 0 ? 'first' : '', 'itemicon']"
          >
            <div class="iconbg" :style="'background:#'+ colorArr[(index) % 4]">
              <svg class="icon" aria-hidden="true" style="color:#fff;">
                <use :href="'#' + item.menuInfo.imgid"></use>
              </svg>
            </div>
            <span>{{item.menuInfo.name}}</span>
          </div>
          <div @click="openDialog" :class="[commonApp.length > 0 ? 'icon_setting' : 'first', 'icon_setting']">
            <div class="iconbg" style="background:#cd7f32;">
              <i class="el-icon-circle-plus-outline"></i>
            </div>
            <span>设置模块</span>
          </div>
        </div>
        <div class="all" >
          <div class="title"><span>全部专题应用</span></div>
          <div class="block" v-for="(item,index) in navallList" :key="index" :class="[index === 3 ? 'blockbottom' : '']" v-show="!item.menuInfo.topColumn">
           <span class="classify">{{item.menuInfo.name}}</span>
            <div @click="todetail(item.menuInfo.url,item.menuInfo)" v-for="(item,index) in navallList[index].chidMenuInfo" :key="index" :class="[index === 0 || index % 9 === 0 ? 'first' : '', index >= 9 ? 'nextitem' : '', 'itemicon']">
              <div class="iconbg" :style="'background:#'+ item.bgcolor">
                <svg class="icon" aria-hidden="true">
                  <use :href="'#' + item.menuInfo.imgid"></use>
                </svg>
              </div>
              <span>{{item.menuInfo.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :modal="false"
      width="50%"
      :fullscreen="false"
      title="栏目选择"
    >
      <div class="dialog_wrapper">
        <div class="wrapper_item" v-for="(item,index) in navallList" :key="index"  v-show="!item.menuInfo.topColumn">
          <div class="item_title">{{item.menuInfo.name}}</div>
          <div class="item_list">
            <el-checkbox-group v-model="checkedNav" @change="handleCheckedNavChange">
              <el-checkbox
                v-for="(item,index) in navallList[index].chidMenuInfo"
                :key="index"
                :label="item.menuInfo.id"
              >{{item.menuInfo.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div style="text-align:center;margin-top:15px;">
        <el-button type="info" @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import userTypes from '@/store/types/user'
import { getSubMenuCache } from '@/views/global/functions'
export default {
  name: 'homepage',
  data () {
    return {
      navallList: [],
      dialogVisible: false,
      checkedNav: [],
      commonAppId: [],
      commonApp: [],
      colorArr: ['48c569', 'e66249', '18a9d9', '9f8ddf'],
      height: document.documentElement.clientHeight - 450 + 'px',
      bannerswiper: [
        // { 'name': '永嘉县', 'imgurl': require('@/assets/homepage_img/fxq.png'), 'imgrouter': 'yjxbasin' },
        // { 'name': '梅雨', 'imgurl': require('@/assets/homepage_img/meiyu.png'), 'imgrouter': 'meiyu' },
        // { 'name': '台风', 'imgurl': require('@/assets/homepage_img/taifeng.png'), 'imgrouter': 'taifeng' }
      ],
      oftenapps: [
        // { 'name': '实时雨情', 'bgcolor': 'e66249', 'iconcode': 'iconshishiyuqing', 'routerurl': 'Monitor/RealTimeRain' },
        // { 'name': '河道水情', 'bgcolor': '19a8d8', 'iconcode': 'iconhedaoshuiqing', 'routerurl': 'Monitor/RiverWater' },
        // { 'name': '水库水情', 'bgcolor': '48c569', 'iconcode': 'iconshuikushuiqing', 'routerurl': 'Monitor/ReservoirWater' },
        // { 'name': '短临预报', 'bgcolor': '9f8ddf', 'iconcode': 'iconduanlinyubao', 'routerurl': 'Monitor/ShortForecast' },
        // { 'name': '综合雨水情', 'bgcolor': '498df2', 'iconcode': 'iconzongheshuiyuqing', 'routerurl': 'Monitor/WaterAndRainStatistics' },
        // { 'name': '实时信息发送', 'bgcolor': 'e66249', 'iconcode': 'iconshishixinxifasong', 'routerurl': 'WarningCenter/RealTimeMsgSend' },
        // { 'name': '预警信息查看', 'bgcolor': '9f8ddf', 'iconcode': 'iconyujingxinxichakan', 'routerurl': 'WarningCenter/warnInformationView' }
      ],
      all: [{ 'name': '实时雨情', 'bgcolor': '498df2', 'iconcode': 'iconshishiyuqing', 'routerurl': 'Monitor/RealTimeRain' },
        { 'name': '雨量统计', 'bgcolor': '9f8ddf', 'iconcode': 'iconyuliangtongji', 'routerurl': 'Monitor/RainStatis' },
        { 'name': '河道水情', 'bgcolor': '48c569', 'iconcode': 'iconhedaoshuiqing', 'routerurl': 'Monitor/RiverWater' },
        { 'name': '水库水情', 'bgcolor': '19a8d8', 'iconcode': 'iconshuikushuiqing', 'routerurl': 'Monitor/ReservoirWater' },
        { 'name': '综合雨水情', 'bgcolor': '498df2', 'iconcode': 'iconzongheshuiyuqing', 'routerurl': 'Monitor/WaterAndRainStatistics' },
        { 'name': '天气预报', 'bgcolor': '48c569', 'iconcode': 'icontianqiyubao', 'routerurl': 'Monitor/Weather' },
        { 'name': '台风路径', 'bgcolor': 'e66249', 'iconcode': 'icontaifenglujing', 'routerurl': 'Monitor/Typhoon' },
        { 'name': '卫星云图', 'bgcolor': '9f8ddf', 'iconcode': 'iconweixingyuntu', 'routerurl': 'Monitor/Satellite' },
        { 'name': '雷达图', 'bgcolor': '19a8d8', 'iconcode': 'iconleidatu', 'routerurl': 'Monitor/Radar' },
        { 'name': '短临预报', 'bgcolor': '48c569', 'iconcode': 'iconduanlinyubao', 'routerurl': 'Monitor/ShortForecast' },
        { 'name': '视频监控', 'bgcolor': 'e66249', 'iconcode': 'iconshipinjiankong', 'routerurl': 'Monitor/VideoSur' },
        { 'name': '预警管理', 'bgcolor': '19a8d8', 'iconcode': 'iconyujingguanli', 'routerurl': 'WarningCenter/warninfo' },
        { 'name': '预警信息查看', 'bgcolor': '9f8ddf', 'iconcode': 'iconyujingxinxichakan', 'routerurl': 'WarningCenter/warnInformationView' },
        { 'name': '实时信息发送', 'bgcolor': 'e66249', 'iconcode': 'iconshishixinxifasong', 'routerurl': 'WarningCenter/RealTimeMsgSend' },
        { 'name': '已发短信查询', 'bgcolor': '19a8d8', 'iconcode': 'iconyifaduanxinchaxun', 'routerurl': 'WarningCenter/InquireHasBeenSentSMS' },
        { 'name': '短信模板管理', 'bgcolor': '5689f1', 'iconcode': 'iconduanxinmobanguanli', 'routerurl': 'WarningCenter/smsTemplateManagement' },
        { 'name': '责任人管理', 'bgcolor': '498df2', 'iconcode': 'icongerenxinxi', 'routerurl': 'WarningCenter/Manageinfo' },
        { 'name': '预警人员配置', 'bgcolor': '48c569', 'iconcode': 'iconyujingrenyuanpeizhi', 'routerurl': 'WarningCenter/WarnStaffing' },
        { 'name': '预警类型群组', 'bgcolor': '48c569', 'iconcode': 'iconyujingleixingqunzu', 'routerurl': 'WarningCenter/groupRelations' },
        { 'name': '预报预警查询', 'bgcolor': '48c569', 'iconcode': 'iconyifaduanxinchaxun', 'routerurl': 'WarningCenter/forecastSms' },
        { 'name': '水库', 'bgcolor': '498df2', 'iconcode': 'iconshuiku', 'routerurl': 'Scene/Reservoir' },
        { 'name': '水闸', 'bgcolor': '48c569', 'iconcode': 'iconshuizha', 'routerurl': 'Scene/Sluice' },
        { 'name': '海塘(堤防)', 'bgcolor': '498df2', 'iconcode': 'icondifang', 'routerurl': 'Scene/Dike' },
        { 'name': '塘（堰）坝', 'bgcolor': '9f8ddf', 'iconcode': 'icontangyanba', 'routerurl': 'Scene/Ponddam' },
        { 'name': '自动遥测站', 'bgcolor': '498df2', 'iconcode': 'iconzidongyaocezhan', 'routerurl': 'Scene/Automatic' },
        { 'name': '预案', 'bgcolor': '19a8d8', 'iconcode': 'iconyuanxinxi', 'routerurl': 'Scene/Planinfo' },
        { 'name': '预警指标', 'bgcolor': 'f2a22f', 'iconcode': 'iconzhibiaoguanli', 'routerurl': 'Scene/Indicatorinfo' },
        { 'name': '防治区', 'bgcolor': '19a8d8', 'iconcode': 'iconfangzhiquxinxi', 'routerurl': 'Scene/PreventInfo' },
        { 'name': '历史山洪调查', 'bgcolor': 'e66249', 'iconcode': 'iconlishishanhongtiaochaxinxi', 'routerurl': 'Scene/HisMountain' }]
    }
  },
  methods: {
    openDialog () {
      this.dialogVisible = true
      this.checkedNav = this.commonAppId
    },
    handleSave () {
      if (this.checkedNav.length > 8) {
        this.$message({
          message: '选项不能超过8项',
          type: 'warning'
        })
      } else {
        let ids = []
        ids = this.checkedNav
        this.$store.dispatch(userTypes.SAVE_FLOOR_NAV, { ids, type: 'popular' }).then(() => {
          this.$notify.success({ title: '成功', message: '保存成功。' })
          this.getAllFloorNav()
          this.dialogVisible = false
        })
      }
    },
    handleCheckedNavChange () {
      if (this.checkedNav.length > 8) {
        this.$message({
          message: '选项不能超过8项',
          type: 'warning'
        })
      }
    },
    tofloood (path) {
      if (path === 'meiyu') {
        this.$router.push({ path: '../meiyu' })
      } else if (path === 'taifeng') {
        this.$router.push({ path: '../typhoon' })
      } else if (path === 'nonfloodseason') {
        this.$router.push({ path: '../nonfloodseason' })
      } else if (path === 'drought') {
        this.$router.push({ path: '../drought' })
      } else if (path === 'yjxbasin') {
        this.$router.push({ path: '../waterrainbigscreen/yjxbasin' })
      } else if (path === 'riskchart') {
        this.$router.push({ path: '../riskchart' })
      }
    },
    todetail (routername, item) {
      if (item.isLink) {
        window.open(item.url)
      } else {
        this.$router.push({ name: routername })
      }
    },
    getAllFloorNav () {
      this.$store.dispatch(userTypes.GET_NESTED_FLOOR_NAV).then(data => {
        let temp = data.rows[0].menuInfo.name
        if (temp === '常用链接') {
          this.commonApp = data.rows[0].chidMenuInfo
          this.navallList = data.rows.slice(1)
        } else {
          this.commonApp = []
          this.navallList = data.rows
        }
        this.commonAppId = []
        this.commonApp.forEach(item => {
          this.commonAppId.push(item.menuInfo.id)
        })
      })
    }
  },
  mounted () {
    this.getAllFloorNav()
    this.ListSubMenu('').then(res => {
      let menu = getSubMenuCache()
      let obj = menu.find(item => { return item.menuInfo.name === '大屏' })
      let obj1 = menu.find(item => { return item.menuInfo.name === '常用专题' })
      if (obj) {
        this.bannerswiper = obj.chidMenuInfo
      }
      if (obj1) {
        this.oftenapps = obj1.chidMenuInfo
      }
      this.bannerswiper.forEach(el => {
        el.imgurl = require(`@/assets/homepage_img/${el.menuInfo.imgid}`)
      })
    })
  }
}
</script>
<style lang="less" scoped>
.homepage{
  .flood{
    height: 380px;
    background: #f2f4f7;
    padding: 40px 0;
    text-align: center;
    position: relative;
    .title{
      width: 520px;
      text-align: center;
      position: absolute;
      left: 50%;
      margin-left: -260px;
      top: 28px;
      background: #f2f4f7;
      span{
        font-size: 24px;
        color: #333333;
      }
    }
    .contain{
      margin: 0px auto;
      width: 1365px;
      height: 300px;
      display: flex;
      justify-content:space-between;
      border-top: 1px solid #b4b4b4;
      .itembanner{
        cursor: pointer;
        width: 30%;
        height: 260px;
        display: inline-block;
        margin-top: 40px;
        .pic{
          width: 100%;
          height: 220px;
          background: #fff;
          img{
            width: 100%;
            height: 218px;
          }
        }
        .desc{
          width: 100%;
          height: 40px;
          background: #fff;
          span{
            font-size: 20px;
            color: #333333;
            line-height:40px;
          }
        }
      }
    }
    .picblock{
      width: 1400px;
    }
  }
  .application{
    background: #fff;
    padding-top: 40px;
    .contain{
      .flood>.contain;
      background: #fff;
      height: 1000px;
      display: block;
      .often{
        width: 1365px;
        height: 295px;
        position: relative;
        .title{
          .flood>.title;
          top: -15px;
          background: #fff;
        }
        .itemicon{
          cursor: pointer;
          margin-top:60px;
          width: 77px;
          height: 110px;
          text-align: center;
          display: inline-block;
          margin-left: 80px;
          position: relative;
          .iconbg{
            width: 77px;
            height: 77px;
            border-radius: 18px;
            margin-bottom: 20px;
            .icon{
              margin-top: 13px;
              color: #fff;
              width: 45px;
              height: 45px;
            }
          }
          .edit{
            border: 2px dashed #adadad;
            color: #333333;
          }
          span{
            font-size: 16px;
            color: #333333;
            position: absolute;
            width: 135px;
            left: -30px;
          }
        }
        .icon_setting {
          cursor: pointer;
          margin-top:60px;
          width: 77px;
          height: 110px;
          text-align: center;
          display: inline-block;
          margin-left: 80px;
          position: absolute;
          top: 0;
          .iconbg {
            width: 77px;
            height: 77px;
            border-radius: 18px;
            margin-bottom: 20px;
            i {
              text-align: center;
              margin-top: 15px;
              color: #fff;
              font-size: 45px;
              width: 50px;
              height: 50px;
            }
          }
          span {
            font-size: 16px;
            color: #333333;
            position: absolute;
            width: 135px;
            left: -30px;
          }
        }
        .first{
          margin-left: 0;
        }
      }
      .all{
        width: 1365px;
        position: relative;
        border-top: 1px solid #b4b4b4;
        .often;
        .classify{
          position: absolute;
          top: 33px;
          left: 12px;
          font-size: 20px;
          color: #333333;
        }
        .classify:nth-of-type(2){
          .classify;
          top: 60px;
        }
        .itemicon{
          margin-top: 87px;
        }
        .nextitem{
          margin-top:35px;
        }
        .block{
          position: relative;
           .itemicon:nth-of-type(1) .iconbg {
            background: #e66249;
          }
           .itemicon:nth-of-type(2) .iconbg{
            background: #9f8ddf;
          }
           .itemicon:nth-of-type(3) .iconbg{
            background: #19a8d8;
          }
           .itemicon:nth-of-type(4) .iconbg{
            background: #48c569;
          }
          .itemicon:nth-of-type(5) .iconbg{
            background: #e66249;
          }
           .itemicon:nth-of-type(6) .iconbg{
            background: #9f8ddf;
          }
          .itemicon:nth-of-type(7) .iconbg{
            background: #19a8d8;
          }
           .itemicon:nth-of-type(8) .iconbg{
            background: #48c569;
          }
          .itemicon:nth-of-type(9) .iconbg{
            background: #e66249;
          }
          .itemicon:nth-of-type(10) .iconbg{
            background: #9f8ddf;
          }
           .itemicon:nth-of-type(11) .iconbg{
            background: #19a8d8;
          }
           .itemicon:nth-of-type(12) .iconbg{
            background: #48c569;
          }
           .itemicon:nth-of-type(13) .iconbg{
            background: #e66249;
          }
           .itemicon:nth-of-type(14) .iconbg{
            background: #9f8ddf;
          }
           .itemicon:nth-of-type(15) .iconbg{
            background: #19a8d8;
          }
           .itemicon:nth-of-type(16) .iconbg{
            background: #48c569;
          }
        }
      }
    }
  }
  .dialog_wrapper {
    width: 100%;
    .wrapper_item {
      width: 100%;
      margin-bottom: 10px;
      .item_title {
        font-size: 18px;
        font-weight: bold;
        color: #000;
        margin-bottom: 10px;
      }
      .item_list {
        width: 100%;
      }
    }
    /deep/ .el-checkbox {
      margin-right: 20px;
      line-height: 30px;
      width: 120px;
    }
  }
  /deep/ .el-dialog__body {
    padding-bottom: 20px;
  }
}
</style>
